import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M14.318 6.682l1.058-1.058c.001-.001.002-.002.003-.002.829-.829.829-2.172 0-3.001-.414-.414-.957-.621-1.5-.621s-1.086.207-1.5.621L5 10l-2 5 5-2 6.318-6.318zm-1.232-3.354c.212-.211.493-.328.793-.328s.581.117.793.329c.212.211.329.493.329.792 0 .291-.11.564-.309.773l-.374.374-1.586-1.586.354-.354zm-8.291 9.877l1.057-2.643 6.173-6.173 1.586 1.586-6.173 6.173-2.643 1.057zM3 18h14v1H3v-1zM3 16h14v1H3v-1z',
  ],
  height: 20,
  width: 20,
});
